<template>
  <div
    class="font-weight-bold color_thead lighten-2 pl-6 pr-6 pt-3 pb-3 ml-4 mr-4 white--text rounded elevation-4"
    style="top: -15px; position: relative"
  >
    <div class="subtitle-1">
      {{ titre.toUpperCase() }}
    </div>
    <div class="caption">
      {{ sousTitre }}
    </div>
  </div>
</template>

<script>
export default {
  name: "VueMyCardTitle",
  props: {
    color: {
      type: String,
      default: "",
    },
    titre: {
      type: String,
      default: "",
    },
    sousTitre: {
      type: String,
      default: "",
    },
  },
};
</script>

<style scoped></style>
